import { useState } from "react";
import { features } from "@/mocks/features";

export default function Features() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section
      id="technology"
      className="relative w-full py-24 md:py-32 bg-background-50 border-t border-background-200/60"
    >
      <div className="w-full px-6 md:px-10 max-w-[1600px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-[2px] bg-primary-500"></span>
              <span
                className="text-primary-500 text-xs tracking-[0.4em]"
                style={{ fontFamily: "var(--font-label)" }}
              >
                TECHNOLOGY / 5 STRENGTHS
              </span>
            </div>
            <h4
              className="text-foreground-950 text-5xl md:text-7xl leading-[0.9]"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              <a href="#technology" className="hover:text-primary-500 transition-colors cursor-pointer">
                5つの、絶対性能<span className="text-primary-500">.</span>
              </a>
            </h4>
          </div>
          <p className="max-w-md text-foreground-600 text-sm md:text-base leading-relaxed">
            雷撃カゴを唯一無二の存在たらしめる、5つの究極性能。すべては「一投で決める」ための設計思想から生まれています。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((f, idx) => {
            const highlight = idx === activeIndex;
            return (
              <div
                key={f.id}
                onClick={() => setActiveIndex(idx)}
                className={`group relative overflow-hidden rounded-lg p-6 md:p-8 border transition duration-300 cursor-pointer ${
                  highlight
                    ? "bg-primary-500 text-background-50 border-primary-500 lg:col-span-2 lg:row-span-1"
                    : "bg-background-100 border-background-200/60 hover:border-primary-500/50"
                }`}
              >
                <div className="flex items-start justify-between mb-8">
                  <div
                    className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full border transition duration-300 ${
                      highlight
                        ? "border-background-50/50 text-background-50"
                        : "border-foreground-100/20 text-primary-500 group-hover:border-primary-500/40"
                    }`}
                  >
                    <i className={`${f.icon} text-2xl md:text-3xl`}></i>
                  </div>
                  <div className="text-right">
                    <div
                      className={`text-3xl md:text-4xl leading-none transition duration-300 ${
                        highlight ? "text-background-50" : "text-primary-500"
                      }`}
                      style={{ fontFamily: "var(--font-heading)" }}
                    >
                      {f.metric}
                    </div>
                    <div
                      className={`text-[10px] tracking-[0.25em] mt-1 transition duration-300 ${
                        highlight ? "text-background-50/70" : "text-foreground-600"
                      }`}
                    >
                      {f.metricLabel}
                    </div>
                  </div>
                </div>

                <div
                  className={`text-[10px] tracking-[0.35em] mb-3 transition duration-300 ${
                    highlight ? "text-background-50/80" : "text-foreground-600"
                  }`}
                >
                  0{idx + 1} / {f.subtitle}
                </div>
                <h5
                  className={`text-2xl md:text-3xl mb-3 transition duration-300 ${
                    highlight ? "text-background-50" : "text-foreground-950"
                  }`}
                  style={{ fontFamily: f.id === "stability" ? "var(--font-body)" : "var(--font-heading)" }}
                >
                  {f.title}
                </h5>
                <p
                  className={`text-sm leading-relaxed max-w-md transition duration-300 ${
                    highlight ? "text-background-50/85" : "text-foreground-600"
                  }`}
                >
                  {f.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}